import styled from 'styled-components'

export const Card = styled.div`
  padding: 10px;
  background-color: ${props => props.theme === 'light' ? '#fff0fa' : '#1e1b2e'};
  box-shadow: 0 4px 12px rgba(80, 20, 140, 0.15);
  width: 100%;
  opacity: 0;
  transform: translateX(100px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;

  &.visible {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${props => props.theme === 'light' ? '#3b0764' : '#ffffff'};
`
export const Title2 = styled(Title)`
  color: ${props => props.theme === 'light' ? '#9400D3' : '#ffdd95'};
`

export const Description = styled.p`
  font-size: 1rem;
  color: ${props => props.theme === 'light' ? '#4c1d95' : '#ffffff'};
  margin: 12px 0;
`

export const Duration = styled.p`
  font-size: 0.875rem;
  color: ${props => props.theme === 'light' ? '#5b21b6' : '#ffffff'};
`

export const TagsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  list-style-type: none;
  padding-left: 0px;
`

export const Tag = styled.li`
  background-color: #e9d5ff;
  color: #3b0764;
  font-size: 0.75rem;
  padding: 4px 10px;
  border-radius: 8px;
`

export const LinkButton = styled.a`
  display: inline-block;
  margin-top: 12px;
  background-color: #7c3aed;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 0.875rem;
  border-radius: 8px;
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    background-color: #6d28d9;
  }
`
